import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import {
  AppBar,
  Box,
  CircularProgress,
  CssBaseline,
  IconButton,
  Toolbar,
} from "@mui/material/index";
import { BrowserRouter, NavLink, Route, Routes } from "react-router";
import {
  fetchCars,
  selectSyncStatus,
  syncCars,
  updateFilters,
} from "./slices/cars-slice";
import CarListPage from "./pages/car-list";
import CarCreatePage from "./pages/car-create";
import CarDetailsPage from "./pages/car-details";
import CarEditPage from "./pages/car-edit";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { selectAuthenticated, updateToken } from "./slices/auth-slice";
import { AuthContext, IAuthContext } from "react-oauth2-code-pkce";
import logoFull from "./images/logo_full.png";
import { Sync, SyncProblem } from "@mui/icons-material";
import PageNotFound from "./pages/page-not-found";

function App() {
  const isAuthenticated = useAppSelector(selectAuthenticated);
  const syncStatus = useAppSelector(selectSyncStatus);
  const dispatch = useAppDispatch();
  const { token, loginInProgress } = useContext<IAuthContext>(AuthContext);
  const [tokenExpired, setTokenExpired] = useState<boolean>(true);

  useEffect(() => {
    if (token) {
      dispatch(updateToken(token));
      const tokenExpire = localStorage.getItem("ROCP_tokenExpire");
      if (!tokenExpire) return;
      setTokenExpired(Date.now() > parseInt(tokenExpire) * 1000);
    }
  }, [token]);

  const handleCarsSync = () => {
    dispatch(syncCars());
  };

  return (
    <BrowserRouter>
      <CssBaseline />
      <AppBar position="relative">
        <Toolbar>
          <Box flexGrow={1}>
            <NavLink
              color="primary"
              style={{ color: "inherit", textDecoration: "inherit" }}
              to="/"
              onClick={() => {
                dispatch(updateFilters({}));
                dispatch(fetchCars());
              }}
            >
              <img src={logoFull} style={{ maxHeight: 70, maxWidth: "90%" }} />
            </NavLink>
          </Box>

          {syncStatus === "syncing" ? (
            <Box
              sx={{
                display: "flex",
                position: "relative",
                alignItems: "center",
                alignContent: "center",
                justifyContent: "center",
                justifyItems: "center",
              }}
            >
              <CircularProgress
                color="warning"
                style={{ position: "absolute" }}
                size={28}
              />
              <Sync />
            </Box>
          ) : syncStatus === "failed" ? (
            <IconButton onClick={handleCarsSync} style={{ padding: 0 }}>
              <SyncProblem color="warning" />
            </IconButton>
          ) : (
            <IconButton onClick={handleCarsSync} style={{ padding: 0 }}>
              <Sync htmlColor="white" />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      <main>
        <Box
          sx={{
            p: { xs: 2, sm: 4 },
            maxWidth: {
              xs: "100%",
              sm: "70%",
            },
            mx: "auto",
          }}
        >
          {isAuthenticated && !loginInProgress && !tokenExpired ? (
            <Routes>
              <Route path="/" element={<CarListPage />} />
              <Route path="/cars" element={<CarListPage />} />
              <Route
                path="/cars/:id"
                element={
                  <>
                    <CarListPage />
                    <CarDetailsPage />
                  </>
                }
              />
              <Route
                path="/cars/:id/edit"
                element={
                  <>
                    <CarListPage />
                    <CarEditPage />
                  </>
                }
              />
              <Route
                path="/cars/add"
                element={
                  <>
                    <CarListPage />
                    <CarCreatePage />
                  </>
                }
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          ) : (
            "Vous devez être authentifiés"
          )}
        </Box>
      </main>
    </BrowserRouter>
  );
}

export default App;
